import React from 'react'
import { Table, List, Avatar, Button, Skeleton, Steps, Space, Tabs } from 'antd';


function RenderSteps(pr) {

    const { Step } = Steps;
    return (
        <div>
            <Steps style={{ padding: "10px", borderRadius: "0px 10px" }} current={pr.steps}
                percent={pr.steps * 53.4 + 25}>
                {
                    pr.withlabel ? <Step title="Rencana Konseling" description="Tanggal Dan Cara Bayar" /> : <Step />
                }
                {
                    pr.withlabel ? <Step title="Proses Pembayaran" description="Proses Pembayaran" /> : <Step />
                }
                {
                    pr.withlabel ? <Step title="Verifikasi Pembayaran" description="Uraian kegiatan" /> : <Step />
                }
                {/* <Step title="Pembayaran Koseling Selesai" description="Selesai" /> */}
                {/* <Step title="Selesai" description="Selesai" /> */}
            </Steps>
        </div>
    )
}

export default RenderSteps
